import _get from 'lodash/get'
import { baseRequest } from '.'

export const getPromoters = async eventId => {
  const res = await baseRequest.get(`event/${eventId}/promoters`)
  return _get(res, 'data')
}
